import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";

function transform(_ref) {
  var x = _ref.x,
      y = _ref.y,
      scale = _ref.scale,
      rotate = _ref.rotate,
      styles = _objectWithoutPropertiesLoose(_ref, ["x", "y", "scale", "rotate"]);

  var transform = '';

  if (x && y) {
    transform += "translate(" + x + ", " + y + ") ";
  } else {
    if (x) {
      transform += "translateX(" + x + ") ";
    }

    if (y) {
      transform += "translateY(" + y + ") ";
    }
  }

  if (scale) {
    transform += "scale(" + scale + ") ";
  }

  if (rotate) {
    transform += "rotate(" + rotate + "deg) ";
  }

  if (transform.length > 0) {
    styles.transform = styles.transform ? styles.transform + " " + transform : transform;
  }

  return styles;
}

export default transform;